import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'

import { REACT_APP_API_PRINCIPAL_URL } from '../config/settings/environment.config'

/**
 * Gets the user info contained in the token.
 */
export const getAuthInfo = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/auth/info`)
)
